import { render, staticRenderFns } from "./form-entrance.vue?vue&type=template&id=4500196e"
import script from "./form-entrance.vue?vue&type=script&lang=js"
export * from "./form-entrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports